import React, { useState, useEffect } from "react";
import { IoMdRadioButtonOn, IoMdRadioButtonOff } from "react-icons/io";
import { Link } from "react-router-dom"; // Import Link from React Router
import {
  LinkTypeContainer,
  LinkType,
  RadioButton,
  RadioLabel,
  RadioLabelContainer,
  DescriptionContainer,
  Description,
} from "./PaymentLinkType.styles";
import { Tooltip } from "@mui/material";
import { CheckBoxOff, CheckBoxOn, InfoCircle } from "../../../../public/assets";

const paymentType = [
  // {
  //   label: "Products or Subscriptions",
  //   value: "products",
  //   description: "For ecommerce or software as a service",
  //   toolTip: "this is for Products and subscriptions",
  // },
  // {
  //   label: "Charity/Donations",
  //   value: "charity",
  //   description: "Customers choose what to pay or pay what they want",
  //   toolTip: "this is for Products and subscriptions",
  // },
  // {
  //   label: "Adhoc Payment",
  //   value: "adhoc",
  //   description: "Make payment one time without Product detail",
  //   toolTip: "this is for Products and subscriptions",
  // },
  {
    label: "Product Payment",
    value: "adhoc",
    description: "Make payment one time without Product detail",
    toolTip: "this is for Products and subscriptions",
  },
];

interface PaymentType {
  label: string;
  value: string;
  description: string;
}

interface Props {
  onTypeChange: (value: string) => void;
  selected?: string;
}

const PaymentLinkType: React.FC<Props> = ({ onTypeChange, selected }) => {
  const [isActive, setIsActive] = useState<string>((selected || "") as string);

  const handleRadioButton = (value: string) => {
    setIsActive(value);
    onTypeChange(value);
  };

  return (
    <>
      {paymentType.map((type, index) => (
        <LinkTypeContainer key={index}>
          <LinkType>
            <>
              <RadioButton onClick={() => handleRadioButton(type?.value)}>
                {isActive === type?.value ? (
                  <img src="/assets/icons/checkboxOn.svg" />
                ) : (
                  <img src="/assets/icons/checkboxOff.svg" />
                )}
              </RadioButton>
              <DescriptionContainer>
                <RadioLabelContainer>
                  <RadioLabel>{type?.label}</RadioLabel>
                  <Tooltip title={"payment"} arrow>
                    <img src="/assets/svg/info-circle.svg" alt="info" />
                  </Tooltip>
                </RadioLabelContainer>
                <Description>{type?.description}</Description>
              </DescriptionContainer>
            </>
          </LinkType>
        </LinkTypeContainer>
      ))}
    </>
  );
};

export default PaymentLinkType;
